import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SciFiBackdrop from "@/components/SciFiBackdrop";
import CursorTracer from "@/components/CursorTracer";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import CaseStudies from "@/pages/CaseStudies";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import { Toaster } from "sonner";
import { bootstrapTheme, useTheme } from "@/hooks/useTheme";

// Apply stored/system theme before first paint to avoid flash
bootstrapTheme();

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { theme } = useTheme();

  return (
    <div className="relative min-h-screen text-white">
      <CursorTracer />
      <div className="app-scale relative">
        <SciFiBackdrop />
        <Navbar />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            {/* <Route path="/case-studies" element={<CaseStudies />} /> */}
            {/* <Route path="/careers" element={<Careers />} /> */}
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster
        position="bottom-right"
        theme={theme}
        toastOptions={{
          style: {
            border: "1px solid rgb(var(--accent) / 0.4)",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 12,
            letterSpacing: "0.06em",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Shell />
    </BrowserRouter>
  );
}
